import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { isHelpCenterPage } from '@/utils/gladly';

function titleCase(str) {
  return str
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
}

const getSubcategoryName = str => {
  return titleCase(str.replace(/-/g, ' '));
};

function MetaTags(props) {
  const location = useLocation();
  const match = useRouteMatch();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    setTitle(getTitle());
    setDescription(getDescription());
  }, [location.pathname]);

  const getSubCategoryTitle = subcategory => {
    return `${getSubcategoryName(subcategory)} | The Inside`;
  };

  const getSubCategoryDescription = subcategory => {
    return `Shop for custom upholstered ${getSubcategoryName(
      subcategory
    )} name in 100+ prints at The Inside. All products are made from scratch. Customize yours today.`;
  };

  const getTitle = () => {
    if (match.path == '/fabric-swatches') {
      return 'Shop Swatches';
    } else if (match.path == '/design-trade-services') {
      return `Design Trades Services | Trade Discount & Benefits | The Inside`;
    } else if (match.params.frameSlug) {
      return getSubCategoryTitle(match.params.frameSlug);
    } else {
      return `Custom Upholstered Furniture in 100+ Fabrics You'll Love | The Inside`;
    }
  };

  const getDescription = () => {
    if (match.path == '/fabric-swatches') {
      return 'Decorating starts with swatches. Get inspired and order swatches here. Ships for free and arrives a few days later.';
    } else if (match.path == '/contact' || match.path == '/faq') {
      return "Hi there, how can we help? Contact The Inside's all-star Customer Service team anytime, starting with hi@theinside.com or visiting our FAQ page.";
    } else if (match.path == '/design-trade-services') {
      return `The Inside's exclusive trade program allows interior designers, architects, home stagers and more to receive special pricing and benefits on furniture and decor. Sign up today!`;
    } else if (match.params.frameSlug) {
      return getSubCategoryDescription(match.params.frameSlug);
    } else {
      return `Shop custom furniture in 100+ fabrics at The Inside, sustainably made-to-order. Discover the joy of decorating today.`;
    }
  };

  // We overwrite this metatags for products and subcategories

  return (
    <Helmet>
      {!isHelpCenterPage(location.pathname) && <title>{title}</title>}
      <meta name="description" content={description} />
    </Helmet>
  );
}

export default MetaTags;
